import React from 'react'
import { Route, Routes } from "react-router-dom";
import Cuentas from '../components/Admin/Cuentas/Cuentas';

/**
 *
 *
 * @export
 * @function RouterCuentas
 * @extends {Component}
 */
function RouterCuentas(props) {
    return (
        <Routes>
            <Route path="" element={<Cuentas {...props} />} />
        </Routes>
    )
}

export default RouterCuentas;
